import React, { Component } from 'react';
import DashboardPage from '../DashboardPage';
import Wrapper from '../common/Wrapper';

const Dashboard = () => {
  return <Wrapper renderButtonNav = {false} >
    <DashboardPage />
  </Wrapper>
}

export default Dashboard;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/DashboardPage.js